const prefix = "/api";
export const ApiRoute = {
  //Public
  login: `${prefix}/login`,
  logout: `${prefix}/logout`,
  auth: `${prefix}/auth`,
  reset: `${prefix}/reset`,
  //Application
  calendar: `${prefix}/calendar`,
  place: `${prefix}/place`,
  records: `${prefix}/records`,
  user_calendar: `${prefix}/user_calendar`,
  holiday: `${prefix}/holiday`,
  user: `${prefix}/user`,
  dashboard: `${prefix}/dashboard`,
  cron: `${prefix}/cron`,
};
